import { useQuery } from "react-query";

import { fetchSdlDataConfig } from "../../../services";
import { IDataConfigSdl, IKeyStringAndValue } from "../../types/Types";

const useGetDescriptionConfig = (listView: string) => {
  return useQuery("description", async () => {
    const descData = await fetchSdlDataConfig(listView, "description");
    if (descData.data.items.edges.length < 1) {
      return [];
    }
    const data = (descData as IDataConfigSdl)?.data.items.edges[0].node.content
      .data.settings.$values;

    return data?.map((fields: IKeyStringAndValue) => {
      const splitArray = fields.value.split("|");

      const name = fields.name;
      const title = splitArray[0]?.trim();
      const description = splitArray[1]?.trim();

      return { name: name, title: title, description: description };
    });
  });
};
export default useGetDescriptionConfig;
